// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3S8Z7","label":"styles_label__2kShw"};